/**
 * 顾客业绩区间表
 *
 * 原始数据：
 * 公司名称
 * 店面名称
 * 顾客姓名
 * 完成业绩
 *
 * 先按：
 * 公司名称 + 店面名称 + 顾客姓名
 * 汇总业绩
 *
 * 再统计区间
 */

const createRange = () => ({
    count: 0,
    amount: 0,
    rate: '0%'
})

export function analyse(rows) {

    // =====================
    // 第一步：顾客汇总
    // =====================

    const customerMap = {}

    rows.forEach(row => {

        const companyName =
            String(
                row['公司名称'] || ''
            ).trim()

        const storeName =
            String(
                row['店面名称'] || ''
            ).trim()

        const customerName =
            String(
                row['顾客姓名'] || ''
            ).trim()

        if (
            !companyName ||
            !storeName ||
            !customerName
        ) {
            return
        }

        const amount =
            parseFloat(
                row['完成业绩']
            ) || 0

        const key =

            companyName +

            '|' +

            storeName +

            '|' +

            customerName

        if (!customerMap[key]) {

            customerMap[key] = {

                companyName,

                storeName,

                customerName,

                amount: 0

            }

        }

        customerMap[key].amount += amount

    })

    // =====================
    // 第二步：公司统计
    // =====================

    const companyMap = {}

    Object.values(customerMap).forEach(item => {

        const companyName =
            item.companyName

        const amount =
            item.amount

        if (!companyMap[companyName]) {

            companyMap[companyName] = {

                companyName,

                r0_1: createRange(),

                r1_3: createRange(),

                r3_5: createRange(),

                r5_10: createRange(),

                r10_20: createRange(),

                gt20: createRange(),

                total: {

                    count: 0,

                    amount: 0

                }

            }

        }

        const company =
            companyMap[companyName]

        company.total.count++
        company.total.amount += amount

        // 0-1万

        if (amount < 10000) {

            company.r0_1.count++
            company.r0_1.amount += amount

        }

        // 1-3万

        else if (amount < 30000) {

            company.r1_3.count++
            company.r1_3.amount += amount

        }

        // 3-5万

        else if (amount < 50000) {

            company.r3_5.count++
            company.r3_5.amount += amount

        }

        // 5-10万

        else if (amount < 100000) {

            company.r5_10.count++
            company.r5_10.amount += amount

        }

        // 10-20万

        else if (amount < 200000) {

            company.r10_20.count++
            company.r10_20.amount += amount

        }

        // 20万以上

        else {

            company.gt20.count++
            company.gt20.amount += amount

        }

    })

    // =====================
    // 计算业绩占比
    // =====================

    const result =

        Object.values(
            companyMap
        )

    result.forEach(company => {

        const totalAmount =

            company.total.amount

        const ranges = [

            company.r0_1,

            company.r1_3,

            company.r3_5,

            company.r5_10,

            company.r10_20,

            company.gt20

        ]

        ranges.forEach(item => {

            item.amount =

                Number(
                    item.amount.toFixed(2)
                )

            item.rate =

                totalAmount === 0

                    ? '0%'

                    : (

                        item.amount /

                        totalAmount *

                        100

                    ).toFixed(2) + '%'

        })

        company.total.amount =

            Number(
                company.total.amount.toFixed(2)
            )

    })

    // =====================
    // 总计
    // =====================

    const summary = {

        companyName: '总计',

        r0_1: createRange(),

        r1_3: createRange(),

        r3_5: createRange(),

        r5_10: createRange(),

        r10_20: createRange(),

        gt20: createRange(),

        total: {

            count: 0,

            amount: 0

        }

    }

    result.forEach(item => {

        summary.r0_1.count += item.r0_1.count
        summary.r0_1.amount += item.r0_1.amount

        summary.r1_3.count += item.r1_3.count
        summary.r1_3.amount += item.r1_3.amount

        summary.r3_5.count += item.r3_5.count
        summary.r3_5.amount += item.r3_5.amount

        summary.r5_10.count += item.r5_10.count
        summary.r5_10.amount += item.r5_10.amount

        summary.r10_20.count += item.r10_20.count
        summary.r10_20.amount += item.r10_20.amount

        summary.gt20.count += item.gt20.count
        summary.gt20.amount += item.gt20.amount

        summary.total.count += item.total.count
        summary.total.amount += item.total.amount

    })

    const totalAmount =

        summary.total.amount

    ;[
        summary.r0_1,
        summary.r1_3,
        summary.r3_5,
        summary.r5_10,
        summary.r10_20,
        summary.gt20
    ].forEach(item => {

        item.rate =

            totalAmount === 0

                ? '0%'

                : (

                    item.amount /

                    totalAmount *

                    100

                ).toFixed(2) + '%'

    })

    result.push(summary)

    return result

}